import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { DropdownToggleBtn, StyledDropdownMenu } from './dropdown'
import ProfileAvatar from './profileAvatar'
import { userContext } from '../../contexts/userContext'
import { deleteAllCookies } from '../../utils/cookiesHandler'
import { ReactComponent as Power } from '../../assets/svgs/power.svg'
import { ReactComponent as Person } from '../../assets/svgs/person.svg'
import { useTheme } from '../../contexts/themeContext'
import apiAuth from "../../features/auth/services/auth"

export default function ProfileMenu() {
  const { theme } = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const user = React.useContext(userContext)
  const [menu, setMenu] = React.useState(false)

  const removeLocalStorageValues = (keysToRemove) => {
    keysToRemove.forEach((key) => {
      localStorage.removeItem(key)
    })
  }

  const handleLogout = () => {
    deleteAllCookies()
    removeLocalStorageValues(['previousCompany', 'currentCompany', 'customColor'])
    apiAuth.logout().then(() => { window.location.href = '/login' })
  }
  const goToUserProfile = () => navigate('/profile?tab=user')

  return (
    <Dropdown
      show={menu}
      onToggle={() => setMenu(!menu)}
      className="d-inline-block"
    >
      <DropdownToggleBtn
        className="btn header-item "
        id="page-header-user-dropdown"
        tag="button"
        color={theme.headerSafeTextColor}
      >
        <ProfileAvatar
          size={2.2}
          name={user.state?.fullname}
          picture={user.state?.picture}
        />
      </DropdownToggleBtn>
      <StyledDropdownMenu className="h-auto">
        <center className="mt-2 mx-2">
          <code>{user.state?.fullname}</code>
          <p>{user.state?.email}</p>
        </center>
        {user?.state?.isActive && (
          <>
            <div className="dropdown-divider" />
            <DropdownItem as="button" onClick={goToUserProfile}>
              <Person className="me-2" />
              {t('layout.profile')}
            </DropdownItem>
          </>
        )}
        <div className="dropdown-divider" />
        <DropdownItem as="button" onClick={handleLogout}>
          <Power className=" align-middle me-1 text-danger" />
          <span>{t('layout.logout')}</span>
        </DropdownItem>
      </StyledDropdownMenu>
    </Dropdown>
  )
}
